import { all, call, fork, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { CourseActionTypes } from './types'
import { listSuccess, listError, updateSuccess, updateError, createSuccess, createError, deleteSuccess, deleteError } from './actions'
import { CourseUtil } from '../../utils/courseUtil';

const courseUtil: CourseUtil = new CourseUtil();
const getCourses = async (searchParams: any) => {
  return await courseUtil.GetList(searchParams);
}
const createCourse = async (doc: any) => {
  return await courseUtil.Create(doc);
}
const updateCourse = async (keyValues: any) => {
  return await courseUtil.Update(keyValues);
}
const deleteCourse = async (id:string, year:number) => {
  return await courseUtil.Delete(id, year);
}

function* handleList(action: any) {
  try {
    const res = yield call(getCourses, action.payload);
    if (res.isSuccess) {
      yield put(listSuccess(res))
    } else {
      yield put(listError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(listError(err.stack))
    } else {
      yield put(listError('An unknown error occured.'))
    }
  }
}

function* handleCreate(action: any) {
  try {
    const res = yield call(createCourse, action.payload);
    if (res.isSuccess) {
      yield put(createSuccess(res.doc))
    } else {
      yield put(createError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(createError(err.stack))
    } else {
      yield put(createError('An unknown error occured.'))
    }
  }
}

function* handleUpdate(action: any) {
  try {
    const res = yield call(updateCourse, action.payload);
    if (res.isSuccess) {
      yield put(updateSuccess(res.doc))
    } else {
      yield put(updateError({"errors": res.errors, "isConflict": res.isConflict}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(updateError(err.stack))
    } else {
      yield put(updateError('An unknown error occured.'))
    }
  }
}

function* handleDelete(action: any) {
  try {
    const res = yield call(deleteCourse, action.payload.id, action.payload.period);
    if (res.isSuccess) {
      yield put(deleteSuccess(res.doc.id)); // Return delete
    } else {
      yield put(deleteError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(deleteError(err.stack))
    } else {
      yield put(deleteError('An unknown error occured.'))
    }
  }
}

function* watchListRequest() {
  yield takeEvery(CourseActionTypes.LIST_REQUEST, handleList)
}

function* watchCreateRequest() {
  yield takeEvery(CourseActionTypes.CREATE_REQUEST, handleCreate)
}

function* watchUpdateRequest() {
  yield takeEvery(CourseActionTypes.UPDATE_REQUEST, handleUpdate)
}

function* watchDeleteRequest() {
  yield takeEvery(CourseActionTypes.DELETE_REQUEST, handleDelete)
}

function* CoursesSaga() {
  yield all([fork(watchListRequest), fork(watchUpdateRequest), fork(watchCreateRequest), fork(watchDeleteRequest)]);
}

export default CoursesSaga
